import { render, staticRenderFns } from "./coming.vue?vue&type=template&id=e322b9dc&scoped=true"
import script from "./coming.vue?vue&type=script&lang=js"
export * from "./coming.vue?vue&type=script&lang=js"
import style0 from "./coming.vue?vue&type=style&index=0&id=e322b9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e322b9dc",
  null
  
)

export default component.exports